// baseSettingsKeys.js
//
// User-settings field names for Base vocabulary.
// Writers set canonical keys only. Readers still accept legacy keys.

export const ACTIVE_BASE_SETTING_KEY = 'ACTIVE_BASE_KEY';
export const LEGACY_ACTIVE_WORKSPACE_SETTING_KEY = 'ACTIVE_WORKSPACE_KEY';

export const BASE_RAIL_ORDER_SETTING_KEY = 'BASE_RAIL_ORDER';
export const LEGACY_WORKSPACE_RAIL_ORDER_SETTING_KEY = 'WORKSPACE_RAIL_ORDER';

/**
 * Resolves the active base key from user settings (new key, then legacy).
 *
 * @param {object|null|undefined} settings
 * @returns {string}
 */
export function getActiveBaseKeyFromSettings(settings) {
  const next = String(settings?.[ACTIVE_BASE_SETTING_KEY] || '').trim();
  if (next) return next;
  return String(settings?.[LEGACY_ACTIVE_WORKSPACE_SETTING_KEY] || '').trim();
}

/**
 * Patch that writes the canonical active-base key.
 *
 * @param {string} baseKey
 * @returns {{ ACTIVE_BASE_KEY: string }}
 */
export function buildActiveBaseSettingPatch(baseKey) {
  const key = String(baseKey || '').trim();
  return {
    [ACTIVE_BASE_SETTING_KEY]: key,
  };
}

/**
 * Resolves rail order from user settings (new key, then legacy).
 *
 * @param {object|null|undefined} settings
 * @returns {*}
 */
export function getBaseRailOrderFromSettings(settings) {
  if (settings && Object.prototype.hasOwnProperty.call(settings, BASE_RAIL_ORDER_SETTING_KEY)) {
    return settings[BASE_RAIL_ORDER_SETTING_KEY];
  }
  return settings?.[LEGACY_WORKSPACE_RAIL_ORDER_SETTING_KEY];
}

/**
 * Patch that writes the canonical rail-order key.
 *
 * @param {string[]} orderKeys
 * @returns {object}
 */
export function buildBaseRailOrderSettingPatch(orderKeys) {
  return {
    [BASE_RAIL_ORDER_SETTING_KEY]: orderKeys,
  };
}
